var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "#F1001E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7125 11.2125C10.5208 11.4042 10.2833 11.5 10 11.5C9.71667 11.5 9.47917 11.4042 9.2875 11.2125C9.09583 11.0208 9 10.7833 9 10.5V6.5C9 6.21667 9.09583 5.97917 9.2875 5.7875C9.47917 5.59583 9.71667 5.5 10 5.5C10.2833 5.5 10.5208 5.59583 10.7125 5.7875C10.9042 5.97917 11 6.21667 11 6.5V10.5C11 10.7833 10.9042 11.0208 10.7125 11.2125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7125 14.2125C10.5208 14.4042 10.2833 14.5 10 14.5C9.71667 14.5 9.47917 14.4042 9.2875 14.2125C9.09583 14.0208 9 13.7833 9 13.5C9 13.2167 9.09583 12.9792 9.2875 12.7875C9.47917 12.5958 9.71667 12.5 10 12.5C10.2833 12.5 10.5208 12.5958 10.7125 12.7875C10.9042 12.9792 11 13.2167 11 13.5C11 13.7833 10.9042 14.0208 10.7125 14.2125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.100c94677a4940e8e3801591f9c380f4.svg";
export { ForwardRef as ReactComponent };